var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCloseMenuMobile = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close_mobile 40"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#49505A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.5379 29.3112L22.0629 19.9502L22.1626 19.8506L31.5379 10.4896C31.8371 10.2905 31.9368 9.89212 31.9368 9.49378C31.9368 9.09544 31.7373 8.6971 31.5379 8.39834C31.2387 8.19917 30.8397 8 30.4408 8C30.0418 8 29.6429 8.19917 29.3437 8.39834L19.9684 17.8589V17.7593L10.5932 8.39834C10.2939 8.09959 9.895 8 9.49605 8C9.0971 8 8.69816 8.09959 8.39895 8.39834C7.90026 8.99585 7.90026 9.9917 8.39895 10.5892L17.8739 19.9502L17.7742 20.0498L8.39895 29.4108C8.19947 29.61 8 30.0083 8 30.4066C8 30.805 8.19947 31.2033 8.39895 31.5021C8.69816 31.7012 9.0971 31.9004 9.49605 31.9004C9.895 31.9004 10.2939 31.7012 10.5932 31.5021L19.9684 22.1411L20.0681 22.2407L29.4434 31.6017C29.7426 31.9004 30.1416 32 30.5405 32C30.9394 32 31.3384 31.8008 31.6376 31.6017C32.1363 30.9046 32.1363 29.9087 31.5379 29.3112Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloseMenuMobile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close-menu-mobile.bc4f04a7.svg";
export { ForwardRef as ReactComponent };